import React from 'react';
import { Store } from 'react-notifications-component';

const _settings = {
	insert: 'top',
	container: 'top-right',
	animationIn: ['animate__animated', 'animate__fadeIn'],
	animationOut: ['animate__animated', 'animate__fadeOut'],
	dismiss: {
		duration: 5000,
		pauseOnHover: true,
		onScreen: true,
		showIcon: true,
		waitForAnimation: true,
	},
};

const normalizeNotificationContent = (value, fallback = '') => {
	if (React.isValidElement(value)) return value;
	if (value instanceof Error) return value.message || fallback;
	if (value === null || value === undefined) return fallback;
	if (typeof value === 'string' || typeof value === 'number') return String(value);
	return fallback || String(value);
};

const showNotification = (title, message, type = 'default') => {
	Store.addNotification({
		title: normalizeNotificationContent(title, 'Notification'),
		message: normalizeNotificationContent(message, 'Something went wrong'),
		type,
		..._settings,
	});
};

export default showNotification;
